<template>
  <div class="product-categories-container">
    <div class="top-title-card">
      <h2 class="page-main-title">商品分类管理</h2>
      <p class="title-desc">管理商品分类，支持添加、编辑和删除</p>
    </div>

    <div class="card-layout">
      <div class="operation-card">
        <div class="card-title">操作面板</div>
        <div class="operation-buttons">
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增分类</el-button>
          <el-button type="success" icon="el-icon-refresh" @click="loadList">刷新列表</el-button>
        </div>
      </div>

      <div class="category-list-card">
        <div class="card-title">分类列表</div>
        <div v-if="list.length === 0" class="empty-card">
          <el-empty description="暂无分类数据" :image-size="100">
            <el-button type="primary" @click="handleAdd">立即新增</el-button>
          </el-empty>
        </div>
        <div v-else class="category-list-wrapper">
          <div v-for="item in list" :key="item.id" class="category-item">
            <div class="item-info">
              <span class="item-id">#{{ item.id }}</span>
              <span class="item-name">{{ item.name }}</span>
            </div>
            <div class="item-actions">
              <el-button size="mini" type="text" icon="el-icon-edit" @click="handleEdit(item)">编辑</el-button>
              <el-button size="mini" type="text" icon="el-icon-delete" style="color:#F56C6C" @click="handleDelete(item)">删除</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
        :title="isEdit ? '编辑分类' : '新增分类'"
        :visible.sync="dialogVisible"
        width="480px"
        :close-on-click-modal="false"
        :append-to-body="true"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="80px" size="small">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入分类名称" maxlength="50" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortOrder" :min="0" :max="999" style="width:100%;" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="handleSave">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/utils/api"

export default {
  name: 'ProductCategory',
  data() {
    return {
      loading: false,
      list: [],
      dialogVisible: false,
      saving: false,
      isEdit: false,
      form: { id: null, name: '', sortOrder: 0 },
      rules: { name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }] }
    }
  },
  mounted() { this.loadList() },
  methods: {
    async loadList() {
      this.loading = true
      try {
        const res = await api.product_getCategoryList({}, null)
        const data = res.data || res
        if (data.code === '000') {
          this.list = data.data.list || data.data || []
        }
      } catch (e) { this.$message.error('加载失败') }
      finally { this.loading = false }
    },
    handleAdd() {
      this.isEdit = false
      this.form = { id: null, name: '', sortOrder: 0 }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleEdit(row) {
      this.isEdit = true
      this.form = { id: row.id, name: row.name, sortOrder: row.sortOrder || 0 }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    async handleSave() {
      try {
        await this.$refs.formRef.validate()
        this.saving = true
        const params = { id: this.form.id, name: this.form.name, sortOrder: this.form.sortOrder }
        const res = this.isEdit
            ? await api.product_updateProductCategory(params, null)
            : await api.product_addProductCategory(params, null)
        const d = res.data || res
        if (d.code === '000') {
          this.$message.success(this.isEdit ? '修改成功' : '添加成功')
          this.dialogVisible = false
          this.loadList()
        } else { this.$message.error(d.message || '操作失败') }
      } catch (e) { if (e !== 'cancel') this.$message.error('操作失败') }
      finally { this.saving = false }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定删除该分类吗？', '提示', { type: 'warning' })
        const res = await api.product_deleteProductCategory({ id: row.id }, null)
        const d = res.data || res
        if (d.code === '000') { this.$message.success('删除成功'); this.loadList() }
        else this.$message.error(d.message || '删除失败')
      } catch (e) {}
    }
  }
}
</script>

<style lang="scss" scoped>
.product-categories-container {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
  box-sizing: border-box;
}

.top-title-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);

  .page-main-title { margin: 0 0 8px; font-size: 20px; color: #303133; font-weight: 600; }
  .title-desc { margin: 0; font-size: 14px; color: #909399; }
}

.card-layout {
  display: flex;
  gap: 20px;
  @media (max-width: 992px) { flex-direction: column; }
}

.operation-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  width: 200px;
  flex-shrink: 0;
  align-self: flex-start;

  .card-title { padding: 16px 20px; font-size: 16px; font-weight: 600; color: #303133; border-bottom: 1px solid #ebeef5; }
  .operation-buttons {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    .el-button { width: 100%; margin: 0; }
  }
}

.category-list-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  flex: 1;

  .card-title { padding: 16px 20px; font-size: 16px; font-weight: 600; color: #303133; border-bottom: 1px solid #ebeef5; }
  .empty-card { padding: 60px 20px; text-align: center; }
  .category-list-wrapper { padding: 16px 20px; }
}

.category-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  margin-bottom: 10px;
  &:last-child { margin-bottom: 0; }
  &:hover { border-color: #409eff; background: #f0f9ff; }

  .item-info {
    display: flex;
    align-items: center;
    gap: 12px;
    .item-id { font-size: 12px; color: #909399; background: #f5f7fa; padding: 2px 8px; border-radius: 4px; }
    .item-name { font-size: 15px; font-weight: 500; color: #303133; }
  }

  .item-actions { display: flex; gap: 4px; flex-shrink: 0; }
}
</style>